import { render, staticRenderFns } from "./deslindes-evento.vue?vue&type=template&id=d7cc5cec&"
import script from "./deslindes-evento.vue?vue&type=script&lang=js&"
export * from "./deslindes-evento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports